import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

interface IProps {
  handleYesClick: () => void;
  handleNoClick: () => void;
}

export const CsatQuestion: React.FC<IProps> = ({
  handleNoClick,
  handleYesClick,
}) => {
  return (
    <>
      <Spacer height="4x" />
      <Typography variant="paragraphSansRegular">
        <StrictLocalMsg
          defaultMessage="Was this helpful?"
          description={{ text: "Ask if these articles are helpful" }}
        />
      </Typography>
      <Spacer height="1x" />
      <Row>
        <RoundedButton onClick={handleYesClick}>
          <StrictLocalMsg
            defaultMessage="Yes"
            description={{
              img: "https://cdn.faire.com/fastly/1d4b202d7b70e7f715312548a8834f7ee9ecffb02846ff973d14576110f3ee02.png",
            }}
          />
        </RoundedButton>
        <Spacer width="2x" />
        <RoundedButton onClick={handleNoClick}>
          <StrictLocalMsg
            defaultMessage="No"
            description={{
              img: "https://cdn.faire.com/fastly/1d4b202d7b70e7f715312548a8834f7ee9ecffb02846ff973d14576110f3ee02.png",
            }}
          />
        </RoundedButton>
      </Row>
    </>
  );
};

const RoundedButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Core.surface.subdued};
  border-radius: ${getSpacing("3x")};
  padding: ${getSpacing("1x", "3x")};
  cursor: pointer;
  font-size: 14px;
  & > p {
    pointer-events: none;
  }

  &:hover {
    background-color: ${Core.surface.subdued};
  }
`;
